import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {toast} from 'sonner'
import {Cancel as CancelIcon, Replay as ReplayIcon} from '@mui/icons-material'
import CustomMenuItem from 'components/Control/ActionMenuItem/CustomMenuItem'
import {useCancelJobMutation, useRetryJobMutation} from 'store/Store'

const useQueueJobActions = ({refetchStats}) => {
    const {t} = useTranslation()
    const [cancelJob] = useCancelJobMutation()
    const [retryJob] = useRetryJobMutation()

    const onCancelJob = (job) => {
        toast.promise(
            cancelJob({queueName: job.name, jobId: job.id})
                .unwrap()
                .then(() => refetchStats()),
            {
                loading: t('loading'),
                success: t('settings.queueManagement.cancelJobSuccess'),
                error: (err) => err?.data?.error || t('settings.queueManagement.cancelJobError'),
            }
        )
    }

    const onRetryJob = (job) => {
        toast.promise(
            retryJob({queueName: job.name, jobId: job.id})
                .unwrap()
                .then(() => refetchStats()),
            {
                loading: t('loading'),
                success: t('settings.queueManagement.retryJobSuccess'),
                error: t('settings.queueManagement.retryJobError'),
            }
        )
    }

    const jobTableActions = useMemo(
        () => [
            {
                MenuItem: CustomMenuItem,
                title: 'cancel_job',
                Icon: CancelIcon,
                onClick: (e, row) => {
                    e.stopPropagation()
                    onCancelJob(row)
                },
                disabled: (row) => row?.state === 'active',
            },
            {
                MenuItem: CustomMenuItem,
                title: 'retry_job',
                Icon: ReplayIcon,
                onClick: (e, row) => {
                    e.stopPropagation()
                    onRetryJob(row)
                },
                disabled: (row) => row?.state !== 'failed',
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [cancelJob, retryJob, t]
    )

    return {jobTableActions}
}

export default useQueueJobActions
